import InvStratMemberInfo from '@/app/modules/toolkit/inv-strat/components/inv-strat-member-info/inv-strat-member-info.vue';
import InvStratGetStarted from '@/app/modules/toolkit/inv-strat/components/inv-strat-get-started/inv-strat-get-started.vue';
import InvStratStrategy from '@/app/modules/toolkit/inv-strat/containers/inv-strat-strategy/inv-strat-strategy.vue';
import InvStratDiversification from '@/app/modules/toolkit/inv-strat/containers/inv-strat-diversification/inv-strat-diversification.vue';
import InvStratInsurance from '@/app/modules/toolkit/inv-strat/components/inv-strat-insurance/inv-strat-insurance.vue';
import InvStratReview from '@/app/modules/toolkit/inv-strat/components/inv-strat-review/inv-strat-review.vue';
import { types } from '@/app/filters/filters';

export default {
  name: 'inv-strat-container',
  components: {
    InvStratMemberInfo,
    InvStratGetStarted,
    InvStratStrategy,
    InvStratDiversification,
    InvStratInsurance,
    InvStratReview,
  },
  data: () => ({
    devMode: process.env.NODE_ENV,
    currentStep: 0,
    hasDiversification: false,
    stepperData: {
      title: 'Investment Strategy',
      style: 'blue',
      steps: [
        {
          step: 1,
          name: 'Member Info',
          component: 'inv-strat-member-info',
        },
        {
          step: 2,
          name: 'Get Started',
          component: 'inv-strat-get-started',
        },
        {
          step: 3,
          name: 'Strategy',
          component: 'inv-strat-strategy',
        },
        {
          step: 4,
          name: 'Insurance',
          component: 'inv-strat-insurance',
        },
        {
          step: 5,
          name: 'Review',
          component: 'inv-strat-review',
        },
      ],
    },
  }),
  methods: {
    saveStrat() {
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch('toolkit/saveItem').catch((err) => {});
    },
    handleStepChange(step) {
      if (this.currentStep === 2 && this.hasDiversification) {
        this.hasDiversification = !this.hasDiversification;
      }
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.strat.status),
        type: this.strat.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Step',
        uuid: this.strat.uuid,
      });

      this.currentStep = step;
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleBackStep() {
      if (this.currentStep === 2 && this.hasDiversification) {
        this.hasDiversification = !this.hasDiversification;
      } else {
        this.currentStep -= 1;
      }
      this.saveStrat();
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.strat.status),
        type: this.strat.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Back',
        uuid: this.strat.uuid,
      });
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleNextStep() {
      if (this.currentStep === 2 && this.hasDiversification) {
        this.hasDiversification = !this.hasDiversification;
      }
      this.saveStrat();
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.strat.status),
        type: this.strat.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Next',
        uuid: this.strat.uuid,
      });
      this.currentStep += 1;
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleHasDiversification() {
      this.hasDiversification = true;
      this.saveStrat();
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
  },
  computed: {
    currentComponent() {
      return (this.currentStep === 2 && this.hasDiversification)
        ? 'inv-strat-diversification'
        : this.stepperData.steps[this.currentStep].component;
    },
    strat() {
      return this.$store.getters['toolkit/getItem'];
    },
    isComplete() {
      return this.strat.status === 'COMPLETE';
    },
  },

};
